module.exports = __webpack_public_path__ + "img/check.11b63f89.svg";